import HomeScreen from '../../screens/HomeScreen';

export default HomeScreen.Main;
